<template>
  <div class="right-col-block blocks">
    <AllAboutMe />
    <Experience />
    <Skills />
    <Education />
    <Awards />
    <Interest />
    <Portfolio />
    <Contact />
    <AppFooter />
  </div>
</template>
<script>
import AllAboutMe from './components/all-about-me'
import Experience from './components/experience'
import Education from './components/education'
import Interest from './components/interest'
import Portfolio from './components/portfolio'
import Contact from './components/contact'
import AppFooter from './components/footer'
import Skills from './components/skills'
import Awards from './components/awards'

export default {
  components: {
    AllAboutMe,
    Experience,
    Skills,
    Education,
    Interest,
    Portfolio,
    Contact,
    AppFooter,
    Awards
  }
}
</script>
